/** Soft light bg + dark text pairs for initials avatars (stable per name). */
export const AVATAR_PALETTE = [
  { bg: '#DCE8F8', color: '#174A84' },
  { bg: '#E4E1F7', color: '#51439B' },
  { bg: '#DCEFEA', color: '#236B5B' },
  { bg: '#F7E8D6', color: '#9A5A19' },
  { bg: '#E7EAF1', color: '#475467' },
  { bg: '#F2E1E5', color: '#93485B' },
  { bg: '#E1EDF2', color: '#356477' },
  { bg: '#EBE5DC', color: '#735B3E' },
] as const;

export type AvatarPalette = (typeof AVATAR_PALETTE)[number];

const hashName = (name?: string | null): number => {
  const value = String(name || '').trim();
  if (!value) return 0;
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
};

/** Returns a stable palette entry for the given name. */
export const getAvatarPalette = (name?: string | null): AvatarPalette => {
  return AVATAR_PALETTE[hashName(name) % AVATAR_PALETTE.length];
};

/** Background color only (for callers that don't need text color). */
export const getAvatarColor = (name?: string | null): string => getAvatarPalette(name).bg;

export type TableAvatarSize = 32 | 36;

/**
 * Preferred initials avatar style for tables:
 * soft pastel bg, dark matching text, circular, no gradient/shadow, weight 600.
 */
export const getTableAvatarSx = (name?: string | null, size: TableAvatarSize = 32) => {
  const palette = getAvatarPalette(name);
  return {
    width: size,
    height: size,
    bgcolor: palette.bg,
    color: palette.color,
    fontSize: size === 36 ? '0.8125rem' : '0.75rem',
    fontWeight: 600,
    borderRadius: '50%',
    boxShadow: 'none',
    backgroundImage: 'none',
  } as const;
};
